module.exports = __webpack_public_path__ + "static/fonts/iconfont.706835dd.woff";